import { t } from 'i18next';
import { ComplexTooltip } from '../../../components/presentational/tooltip';
import { asset } from '../../../services/assetResolverService';
import { findQualifiedTagForGuild } from '../helpers';

type TQualifiedTagBadgeProps = {
  guildId: number;
  size?: 'small' | 'medium';
  className?: string;
};

/**
 * Renders a badge for qualified guild recruitment tags (e.g., LWIW/Visage badges)
 * based on whether the guild is in an approved list.
 */
export const QualifiedTagBadge = ({ guildId, size = 'small', className }: TQualifiedTagBadgeProps) => {
  const qualifiedTag = findQualifiedTagForGuild(guildId);

  if (!qualifiedTag) {
    return null;
  }

  const imageStyle =
    size === 'small'
      ? { width: 44, aspectRatio: qualifiedTag.badgeAspectRatio }
      : { height: 36 };

  const imagePath = size === 'small' ? qualifiedTag.badgeImagePath : qualifiedTag.badgeLargeImagePath;

  return (
    <ComplexTooltip placement="top" tooltip={t(qualifiedTag.tooltipLocKey)}>
      <img src={asset(imagePath)} style={imageStyle} className={className} />
    </ComplexTooltip>
  );
};
